import AdBanner from './ad-banner'

export default function AdBannerWrapper({ ad, placement, index }) {
  if (!ad) {
    return null
  }

  return (
    <div className="w-full">
      <AdBanner ad={ad} placement={placement} />
    </div>
  )
}
